import "./artwork_browser.scss";

import { ArtCard } from "@components/art_card/art_card";
import { ArtModalModal } from "@components/art_carousel/art_modal_modal";
import { useModalState } from "@hooks/use_modal_state";
import * as types from "@root/types";
import React, { FC, useState } from "react";

interface ArtworkBrowserProps {
  artPieces: types.ArtPiece[];
}

const ArtworkBrowser: FC<ArtworkBrowserProps> = ({ artPieces }) => {
  const { open, close, isOpen } = useModalState();

  const [initialIdx, setInitialIdx] = useState<number>(0);

  const handleCardClick =
    (index: number): (() => void) =>
    () => {
      setInitialIdx(index);
      open();
    };

  return (
    <>
      <div className="artwork-browser">
        <div className="artwork-browser--grid">
          {artPieces.map((artPiece, idx) => (
            <ArtCard
              key={artPiece.id}
              onClick={handleCardClick(idx)}
              artPiece={artPiece}
              classes="artwork-browser--grid--item"
              withExpandIcon={true}
            />
          ))}
        </div>
      </div>
      <ArtModalModal
        isOpen={isOpen}
        artPieces={artPieces}
        initialIdx={initialIdx}
        close={close}
      />
    </>
  );
};

export { ArtworkBrowser, ArtworkBrowserProps };
